"use strict";
angular.module("workpapers")
  .factory("_", [
    "$window",
    function ($window) {
      return $window._;
    },
  ]);